module.exports = __webpack_public_path__ + "img/type2.b11ce6de.png";